import React, {Component} from 'react';
import { Row, Col, Table, Label } from 'react-bootstrap';
import '../styles/Pricing.less';

class Price extends Component {
    render() {
        return (
            <div className="pricing-block">
                <div className="master">
                    {this.props.master}
                </div>
                <div className="subline">
                    {this.props.subline}
                </div>
                <div className="copy">
                    <span className="huge">"</span> {this.props.copy}
                </div>
                <div className="price">
                    <span>{this.props.price} <sup>/ Monat</sup></span>
                    {/*<div className="divider">oder</div>*/}
                    <small>{this.props.altprice} <sup>/ Einheit</sup></small>
                </div>
            </div>
        )
    }
}

export default class Pricing extends Component {

    render() {
        return (
            <div id="pricing" className="card transition-item">
                <header>
                    <h1>Preise</h1>
                </header>

                <Row className="row-eq-height">
                    <Col md={4} sm={6}>
                        <Price master="30min"
                               subline="Der Anfänger"
                               copy="Ideal für Arbeitstätige mit begrenzter Kapazität an Zeit und Kinder unter 6 Jahren."
                               price="&euro; 114,00"
                               altprice="&euro; 40,00"/>
                    </Col>
                    <Col md={4} sm={6}>
                        <Price master="45min"
                               subline="Der Klassiker"
                               copy="Die Standard Unterrichtseinheit für groß und klein."
                               price="&euro; 149,00"
                               altprice="&euro; 55,00"/>
                    </Col>
                    <Col md={4} sm={6} smOffset={3} mdOffset={0}>
                        <Price master="60min"
                               subline="Der Performer"
                               copy="Für Pianisten mit Anspruch und die, die es werden wollen."
                               price="&euro; 179,00"
                               altprice="&euro; 65,00"/>
                    </Col>
                </Row>

                <h3>Häufig gestellte Fragen</h3>

                <Row>
                    <Col sm={6}>
                        <div className="question">
                            <h4>Sind Probestunden kostenlos?</h4>
                            <p>
                                Nein, Probestunden werden in voller Höhe in Rechnung gestellt, da es sich hierbei um vollständige Unterrichtseinheiten handelt. <br/>
                                Die Lehrkraft bereitet sich in vollem Umfang darauf vor und leistet einen ausführlichen Beratungsservice.
                            </p>
                            <p>
                                Der Unterschied zur regulären Unterrichteinheit liegt darin, dass Probestunden an keinen Vertrag gebunden sind
                                und somit keine Mindestlaufzeit besteht.
                            </p>
                        </div>
                    </Col>
                    <Col sm={6}>
                        <div className="question">
                            <h4>Gibt es Anfahrtskosten?</h4>
                            <p>Ja, bei Hausbesuchen fallen zusätzliche Anfahrtskosten an: <br/>
                            &euro; 7,00 / Einheit <b>oder</b> &euro; 25,00 / Monat</p>
                        </div>
                        <div className="question">
                            <h4>Kann man längere Unterrichtsstunden buchen?</h4>
                            <p>
                                Ja, längere Unterrichtseinheiten sind nach Absprache möglich.
                            </p>
                        </div>
                        <div className="question">
                            <h4>Ist Gruppenunterricht möglich?</h4>
                            <p>
                                Auf Anfrage kann auch hier eine individuelle Lösung gefunden werden.
                            </p>
                        </div>
                    </Col>
                </Row>

                <h3>Downloads</h3>

                <Row>
                    <Col sm={12}>
                        <div className="question">
                            <ul className="list-unstyled">
                                <li><a target="_blank" href="/pdf/Unterrichtsvereinbarung-Monat.pdf">Unterrichtsvereinbarung (pro Monat) <Label>PDF</Label></a><br/><br/></li>
                                <li><a target="_blank" href="/pdf/Unterrichtsvereinbarung.pdf">Unterrichtsvereinbarung (pro Einheit) <Label>PDF</Label></a></li>
                            </ul>
                        </div>
                    </Col>
                </Row>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Pricing.js